module.exports = __webpack_public_path__ + "static/media/image-8.9399a2bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/depto-nuevo/image-8.jpg
// module id = 253
// module chunks = 0